import { PetType } from 'types'

export const PET_TYPES: PetType[] = ['cat', 'dog']
